import { Select, Tag, Button } from 'antd';
import React, { useContext, useEffect, useState } from 'react';
import AppContext from '../../Context/AppContext';
import { AppDataRequired } from '../../App';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronRight, faTags } from '@fortawesome/free-solid-svg-icons';
import { Row } from 'reactstrap';
import { UserOutlined } from '@ant-design/icons';
import './Roles.css';
import AwsServerService from '../../common/util/AwsServerService';
import { useDispatch, useSelector } from 'react-redux';

const SelectedAvatar = ({ label, value, closable, onClose }) => {
  const getUserThumbnailUrl = (zuid) =>
    `https://contacts.zoho.com/file?ID=${zuid}&fs=thumb`;

  return (
    <Tag
      className="CustomeRoleUserTag"
      closable={closable}
      onClose={onClose}
      icon={
        value ? (
          <img className="Icon" src={getUserThumbnailUrl(value)} alt="User" />
        ) : (
          <UserOutlined className="Icon" />
        )
      }
      style={{ marginInlineEnd: 4, justifyContent: "flex-start", gap: "5px" }}
    >
      {label}
    </Tag>
  );
};

export const RoleUserPicker = ({
  mode,
  style,
  filter,
  placeholder,
  className,
  onChange,
  value,
  groupFromProps = [],
  ModulesFromProps,
  disabledCondition,
  userExcludeModuleList = [],
  isRole,
  isInternalUsers,
  onAddNewRole,
  refreshRoles
}) => {
  console.log("isInternalUsers", isInternalUsers);

  const [options, setOptions] = useState({});
  const [expandedGroups, setExpandedGroups] = useState({
    "Zoho Users": true,
    "Roles": true,
    "Accounts": true,
    "Vendors": true,
    "Contacts": true
  }); // Track expanded/collapsed groups

  const AppData = useContext(AppContext);
  const AllModuleUsers = useSelector((state) => state.AppReduxContext.AllModuleUsers);
  const reduxDispatch = useDispatch();

  const [roles, setRoles] = useState([]);
  const [zohoUsers, setZohoUsers] = useState([]);
  const [accounts, setAccounts] = useState([]);

  const { AllUsers } = useContext(AppDataRequired);
  const { dispatch, state } = AppData || {};

  useEffect(() => {
    const fetchOptionsData = async () => {
      try {
        if (AllUsers?.length > 0) {
          const usersList = AllUsers.map((user) => ({
            label: user.full_name,
            value: user.zuid,
            icon: <FontAwesomeIcon icon={faTags} />,
          }));
          setZohoUsers(usersList);
        }

        if (state?.AllAccounts?.length > 0) {
          const accountList = state.AllAccounts.map((account) => ({
            label: account.Account_Name,
            value: account.id,
            icon: <FontAwesomeIcon icon={faTags} />,
          }));

          setAccounts(accountList);
        }
      } catch (error) {
        console.error("Error fetching user/account data:", error);
      }
    };

    const fetchRoles = async () => {
      try {
        const res = await AwsServerService.CrudServiceHandler({
          method: "GET",
          route: "ROLES",
        });
        if (res.data?.length > 0) {
          const rolesList = res.data.filter(role=>{
            if(filter){
              if(role.RoleType == filter){
                return role
              }
            }else{
              return role
            }
          }).map((role) => {
            return {
              label: role.RoleName,
              value: role.ROWID,
              icon: <FontAwesomeIcon icon={faTags} />,
            }
          });
          setRoles(rolesList);
        }
      } catch (err) {
        console.error("Error fetching roles:", err);
      }
    };

    fetchOptionsData();
    fetchRoles();

    if (AllModuleUsers) {
      setOptions(AllModuleUsers);
    }
  }, [state, AllUsers,filter, ModulesFromProps, AllModuleUsers, isRole, isInternalUsers, refreshRoles]);

  // Toggle group collapse/expand
  const toggleGroup = (groupName) => {
    setExpandedGroups((prev) => ({
      ...prev,
      [groupName]: !prev[groupName],
    }));
  };

  const renderDropdownGroups = (label, groupName, groupData) => {
    return (
      <Select.OptGroup
        key={groupName}
        label={
          <div className="group-header" onClick={() => toggleGroup(groupName)} style={{ cursor: "pointer", display: "flex", alignItems: "center" }}>
            <FontAwesomeIcon icon={expandedGroups[groupName] ? faChevronDown : faChevronRight} style={{ marginRight: 5 }} />
            {label}
          </div>
        }
      >
        {expandedGroups[groupName] &&
          groupData.map((o) => (
            <Select.Option key={o.value} value={`${groupName}_${o.value}`} label={o.label}>
              <Row className="p0m0">{SelectedAvatar(o)}</Row>
            </Select.Option>
          ))}
      </Select.OptGroup>
    );
  };

  return (
    <Select
      showSearch
      placeholder={placeholder}
      mode={mode}
      optionFilterProp="label"
      filterOption={(input, option) =>
        option?.label?.toString().toLowerCase().includes(input.toLowerCase())
      }
      style={style || { width: "100%", height: "100%" }}
      value={value || null}
      onChange={(value, option) =>
        onChange && onChange(value, option, groupFromProps)
      }
      allowClear
      disabled={disabledCondition}
      dropdownMatchSelectWidth={false}
      dropdownRender={(menu) => (
        <>
          {menu}

          {onAddNewRole && (
            <div
              style={{
                padding: "8px",
                cursor: "pointer",
                borderTop: "1px solid #f0f0f0",
                color: "#1890ff",
              }}
              onMouseDown={(e) => e.preventDefault()}
              onClick={onAddNewRole}
            >
              + Add Role
            </div>
          )}
        </>
      )}
    >
      {groupFromProps.length > 0 && isRole && renderDropdownGroups("Roles", "Roles", roles)}
      {groupFromProps.length > 0 && isInternalUsers && renderDropdownGroups("Zoho Users", "Zoho Users", zohoUsers)}

      {Object.keys(options).map((moduleName) => (
        (groupFromProps.includes(moduleName) || groupFromProps.includes("All")) &&
        !userExcludeModuleList.includes(moduleName) &&
        renderDropdownGroups(moduleName, moduleName, options[moduleName])
      ))}
    </Select>

  );
};
